<template>
  <footer>
    <div class="foot-top">
      <a href="/user/personalhelp" target="_blank">帮助中心</a>|
      <a href="/agreement/4" target="_blank">关于我们</a>|
      <a href="https://www.dahe.cn/" target="_blank">友情链接</a>
    </div>
    <div class="mt20">
      <p>
        Copyright © 1996-{{year}} DaHe Network<br />Media.Group All Rights Reserved
      </p>
      <p>豫ICP备17023675号-1</p>
      <p>
        <img src="https://uploads.dahe.cn/lxx/img/beian.png" />豫公网安备 41010502003718号
      </p>
      <p>电话：4006371669</p>
      <p>网站不良信息举报邮箱：jubao@dahe.cn</p>
      <p>举报电话：0371-65795751</p>
      <p>
        <a href="https://www.henanjubao.com/" target="_blank"
          ><img
            src="//uploads.dahe.cn/nxy/dahe2017/img/footer-4.png"
            width="71"
            height="29"
        /></a>
        <a href="https://www.12377.cn/" target="_blank"
          ><img
            src="//uploads.dahe.cn/nxy/dahe2017/img/footer-5.png"
            width="71"
            height="29"
        /></a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      year:new Date().getFullYear()
    };
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
footer {
  padding: 10px 20px;
  color: #555555;
  text-align: justify;
  background: #F7F7F7;
  .foot-top {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    a {
      color: #555555;
    }
  }
  p {
    font-size: 14px;
    margin-bottom: 10px;
    line-height: 20px;
    color: #666666;
    img {
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue